import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const Slider = ({ selectedIndex, onChange, range = [1, 50, 100, 200, 500, 1000, 5000] }) => {
    const { theme } = useTheme();

    const handleSliderChange = (event) => {
        const index = parseInt(event.target.value, 10);
        console.log('Selected index:', index);
        const selectedValue = range[index];
        onChange(selectedValue);
    };

    return (
        <div style={{ marginBottom: '20px', width: '100%', accentColor: theme.colors.primary || 'gray' }}>
            <label style={{ color: theme.colors.text }}>Selected count threshold: {range[selectedIndex]}</label>
            <input
                type="range"
                min="0"
                max={range.length - 1}
                step="1"
                value={selectedIndex}
                onChange={handleSliderChange}
                style={{ width: '100%' }}
            />

            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '10px',
                width: '100%',
                position: 'relative'
            }}>
                {range.map((value, index) => (
                    <span
                        key={index}
                        style={{
                            fontSize: '12px',
                            color: theme.colors.textSecondary || theme.colors.text || '#666',
                            position: 'absolute',
                            left: `${(index / (range.length - 1)) * 100}%`,
                            transform: 'translateX(-50%)',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {value}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default Slider;